// document.addEventListener("DOMContentLoaded", () => {
//   const headerWrapper = document.querySelector(".header-wrapper");
//   const menuItems = document.querySelectorAll(".header__inline-menu > ul > li");

//   if (!headerWrapper) return;

//   headerWrapper.addEventListener("click", () => {
//     headerWrapper.classList.add("menu-active,color-scheme-1");
//   });

//   menuItems.forEach(item => {
//     const megaMenu = item.querySelector(".mega-menu__content");

//     if (!megaMenu) return;

//     // Show on hover
//     item.addEventListener("mouseenter", () => {
//       megaMenu.classList.add("mega-menu--open");
//       headerWrapper.classList.add("menu-active");
//     });

//     // Hide on out
//     item.addEventListener("mouseleave", () => {
//       megaMenu.classList.remove("mega-menu--open");
//       headerWrapper.classList.remove("menu-active");
//     });
//   });
// });


document.addEventListener('DOMContentLoaded', function () {
  var imageSlider = new Swiper(".product-slider.swiper", {
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
      clickable: true,
    }
  });
  

});
